export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden bg-background-200 flex items-center justify-center">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20a%20cinematic%20movie%20streaming%20interface%20with%20warm%20dark%20theme%2C%20elegant%20UI%20design%2C%20golden%20accent%20colors%2C%20film%20poster%20thumbnails%2C%20clean%20minimal%20layout%2C%20soft%20screen%20glow%2C%20product%20photography%20style&width=600&height=600&seq=app-qr-97movie-03&orientation=squarish"
              alt="97影视移动端观影"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-100 rounded-full mb-3">
              移动观影
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              随时随地 · 高清追剧
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              97影视全面适配移动端，无需下载APP，打开浏览器即可畅享高清观影体验。
              支持手机、平板等多种设备，全网资源一键搜索，随时随地追剧不等待。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-5">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                <span>手机适配</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-tablet-line text-primary-500 text-lg"></i>
                <span>平板支持</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-speed-up-line text-primary-500 text-lg"></i>
                <span>无需下载</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}